<script>
  export default {
    name: 'registration-status-label',
    props: ['statusId', 'statusName'],
    computed: {
      labelType: function () {
        switch (this.statusId) {
          case 1:
            return 'success'
          case 2:
            return 'default'
          case 3:
            return 'danger'
          case 4:
            return 'warning'
          default:
            return 'gray'
        }
      }
    }
  }
</script>

<template>
    <div>
        <el-tag :type="labelType">{{statusName}}</el-tag>
    </div>
</template>

<style>
    .el-tag {
        padding: 4px 10px;
        height: 24px;
        line-height: 15px;
    }
</style>



// WEBPACK FOOTER //
// StatusLabel.vue?7c4935d2